import { useTranslation } from 'react-i18next'
import { FooterProps } from 'src/components/Footer'
import { colors } from 'src/theme'
import { Icons } from 'src/components/Icon'
import Router from 'src/routes/Router'
import routes from 'src/routes/definitions'
import { LangSwitchProps } from 'src/components/LangSwitch'
import { STheme } from 'src/rest/types/api/Theme'

import { Configuration } from '../../rest/types/Configuration'
import { getThemeColor } from '../Transformers/ThemeTransformer'

const useFooter = ({
  configuration,
  currentLocale,
  langSwitch,
  theme,
}: {
  configuration: Configuration
  currentLocale: string
  langSwitch?: LangSwitchProps
  theme?: STheme
}): FooterProps => {
  const { t } = useTranslation()

  const footerMenu = configuration.menus['footer']?.entries || []

  const socials = {
    title: t('footer.socials.title'),
    links: [
      t('socials.facebook.link')?.trim()
        ? {
            iconProps: { icon: Icons.socialsFacebook },
            href: t('socials.facebook.link')?.trim(),
            label: 'Facebook',
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {},
      t('socials.linkedin.link')?.trim()
        ? {
            iconProps: { icon: Icons.socialsLinkedin },
            href: t('socials.linkedin.link')?.trim(),
            label: 'LinkedIn',
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {},
      t('socials.youtube.link')?.trim()
        ? {
            iconProps: { icon: Icons.socialsYoutube },
            href: t('socials.youtube.link')?.trim(),
            label: 'Youtube',
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {},
      t('socials.instagram.link')?.trim()
        ? {
            iconProps: { icon: Icons.socialsInstagram },
            href: t('socials.instagram.link')?.trim(),
            label: 'Instagram',
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {},
    ].filter((item) => Object.keys(item).length > 0),
  }

  return {
    color: theme ? getThemeColor(theme, 'Secondary') : colors.blueNight,
    langSwitchProps: langSwitch,
    back: {
      href: '#Top',
      label: t('footer.back'),
    },
    links: footerMenu.map((item) => ({
      label: item.title || '',
      href: item.url || '',
    })),
    socials: { ...socials },
    logoProps: {
      htmlTag: 'div',
      title: t('logo.title'),
      linkProps: {
        href: Router.getRouteUrl(routes.home),
        locale: currentLocale,
      },
    },
    copyright: t('copyright'),
  }
}

export default useFooter
